import { gql, TypedDocumentNode } from '@apollo/client'

import { PAGE_FRAGMENT } from 'features/inventory/page/forms/GeneralForm/hooks/useGetPage/api/fragment'
import { Ability } from 'providers/casl/types/ability'
import { Data, Variables } from './types'

export const GET_PAGE = (ability: Ability): TypedDocumentNode<Data, Variables> => gql`
  ${PAGE_FRAGMENT(ability)}

  query getPage($id: ID!) {
    node(id: $id) {
      ...PageFragment
    }
  }
`
